<template>
	<div>
		<el-dialog :visible.sync="isshow" :title="submitqg_lang.title" width="650px" :append-to-body="true" :close-on-click-modal="false">
			<div class="submitqg">
				<el-form size="mini">
					<el-form-item :label="submitqg_lang.handletype" label-width="100px">
						<el-radio-group v-model="qgform.handletype">
						    <el-radio :label="item.name" v-for="(item,index) in handlelist" :key="index">{{item.name}}</el-radio>
						  </el-radio-group>
					</el-form-item>
				</el-form>
				<el-form size="mini" :inline="true" class="demo-form-inline">
					<el-form-item :label="submitqg_lang.area" label-width="100px">
						<el-select  v-model="qgform.area" @change="changearea" style="width:180px">
							<el-option :key="item.value" v-for="item in arealist" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="submitqg_lang.qgproperty" label-width="100px">
						<el-select  v-model="qgform.qgproperty" style="width:180px">
							<el-option :key="item.value" v-for="item in qgpropertylist" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-form size="mini" :inline="true" class="demo-form-inline">
					<el-form-item :label="submitqg_lang.qgcode" label-width="100px">
						<el-select  v-model="qgform.qgcode" style="width:180px">
							<el-option :key="item.value" v-for="item in qgcodelist" :value="item.value" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="submitqg_lang.dscompany" label-width="100px">
						<el-select  v-model="qgform.dscompany" style="width:180px">
							<el-option :key="item.value" v-for="item in companylist_ds" :value="item.label" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-form size="mini" :inline="true" class="demo-form-inline">
					<el-form-item :label="submitqg_lang.wlcompany" label-width="100px">
						<el-select  v-model="qgform.wlcompany" style="width:180px">
							<el-option :key="item.value" v-for="item in companylist_wl" :value="item.label" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="submitqg_lang.zfcompany" label-width="100px">
						<el-select  v-model="qgform.zfcompany" style="width:180px">
							<el-option :key="item.value" v-for="item in companylist_zf" :value="item.label" :label="item.label"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<el-form size="mini" >
					<el-form-item :label="submitqg_lang.bwtype" label-width="100px">
						<el-checkbox-group  v-model="checkedbwtype" @change="changebw">
						    <el-checkbox :key="index" :label="item.label" v-for="(item,index) in bwlist"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
				<div style="height:20px;"></div>
				<div slot="footer" style="text-align:center;">
					<el-button type="success" size="mini" @click="submitqg">{{suretext}}</el-button>
					<el-button size="mini" @click="isshow=false" style="margin-left:10px">{{canceltext}}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	name:'submitqg',
	data() {
		return {
			submitqg_lang:{},
			isshow:false,
			qgform:{
				area:'',
				bw:[],
				qgcode:'',
				dscompany:'',
				wlcompany:'',
				zfcompany:'',
				handletype:'新增',
				qgproperty:''
			},
			handlelist:[{name:'新增'},{name:'修改'},{name:'删除'}],
			arealist:[],
			bwlist:[],
			companylist_ds:[],
			companylist_wl:[],
			companylist_zf:[],
			batch:'',
			pageparam:{},
			suretext:'',
			canceltext:'',
			divclass:'submitqg',
			checkedbwtype:[],
			qgcodelist:[],
			qgpropertylist:[]
		}
	},
	mounted() {
		//import('../../static/' + this.$theme + '/style/morefilter.scss');
		//this.init();
	},
	methods:{
		init(param){
			debugger
			if(param.batch!=undefined)
				this.batch=param.batch;
			else
				this.batch='';
			this.qgform={
				area:'',
				bw:[],
				qgcode:'',
				dscompany:'',
				wlcompany:'',
				zfcompany:'',
				handletype:'新增',
				qgproperty:''
			}
			if(param.searchinfo!=undefined)
				this.searchinfo = param.searchinfo;
			if(param.pageparam!=undefined)
				this.pageparam=param.pageparam;
			
			//debugger
			var that=this;
			this.$public.GetLanguageByMode('submitqg',this).then(res=>{
				//debugger
				if(res.state=='1'){
					that.isshow=true;
					that.suretext=that.$lang.label.public.sure;
					that.canceltext=that.$lang.label.public.cancel;
					that.submitqg_lang=that.$lang.label.submitqg;
					that.GetArea();
					that.getqgcodelist();
				}
			});
		},
		GetArea(){
			var that=this;
			that.checkedbwtype=[];			
			that.bwlist=[];
			that.qgpropertylist=[];
			that.companylist_ds=[];
			that.companylist_wl=[];
			that.companylist_zf=[];
			that.arealist=[];
			
			this.$apipost.get.GetArea().then(res=>{
				if(res.state=='1')
				{
					that.arealist=res.list;
					if(res.list.length>0){
						that.qgform.area=res.list[0].label;
						that.GetBwList();
						that.GetQgCompanyList();
						that.getqglist();
					}
				}
			});
		},
		changearea(e){
			var list=this.arealist.filter(function(b){
				return b.value==e.value;
			});
			if(list.length>0){
				this.qgform.area=list[0].label;
				this.GetBwList();
				this.getqglist();
			}
		},
		getqgcodelist(){
			var that=this;
			this.$apipost.get.dic({type:'关区代码'}).then(res=>{
				if(res.list!=undefined){
					that.qgcodelist=res.list;
					if(res.list.length==1)
						that.qgform.qgcode=res.list[0].value;
				}
			});
		},
		//获取申报企业账号
		getqglist(){
			var that=this;
			var that=this;
			var paraminfo={
				area:this.qgform.area,
				userid:localStorage.getItem('userid')
			}
			that.bwlist=[];
			this.$apipost.get.GetqgList({paraminfo:paraminfo}).then(res=>{
				if(res.list!=undefined){
					that.qgpropertylist=res.list;
					if(res.list.length==1)
						that.qgform.qgproperty=res.list[0].value;
				}
			});
		},
		GetBwList(){
			//获取报文类型
			var that=this;
			var paraminfo={
				area:this.qgform.area,
				userid:localStorage.getItem('userid')
			}
			that.bwlist=[];
			that.checkedbwtype=[];
			this.$apipost.get.GetBwList({paraminfo:paraminfo}).then(res=>{
				//debugger
				if(res.state=='1'){
					if(res.list!=undefined){
						that.bwlist=res.list;
					}
				}
			});
		},
		//获取企业主体信息
		GetQgCompanyList(){
			var that=this;
			var paraminfo={
				area:this.qgform.area,
				userid:localStorage.getItem('userid')
			}
			that.companylist_ds=[];
			that.companylist_wl=[];
			that.companylist_zf=[];
			this.$apipost.get.GetQgCompanyList({paraminfo:paraminfo}).then(res=>{
				//debugger
				if(res.state=='1'){
					if(res.list!=undefined){
						that.companylist_ds=res.list.filter(function(e){
							return e.ds_comtype=='电商企业';
						});
						that.companylist_zf=res.list.filter(function(e){
							return e.ds_comtype=='支付企业';
						});
						that.companylist_wl=res.list.filter(function(e){
							return e.ds_comtype=='物流企业';
						});
						
						if(that.companylist_ds.length==1)
							that.qgform.dscompany=that.companylist_ds[0].label;

						if(that.companylist_zf.length==1)
							that.qgform.zfcompany=that.companylist_zf[0].label;

						if(that.companylist_wl.length==1)
							that.qgform.wlcompany=that.companylist_wl[0].label;
							
					
					}
				}
			});
		},
		changebw(e){
			this.checkedbwtype=e;
		},
		submitqg(){
			if(this.qgform.area.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.submitqg_lang.area,'0');
				return false;
			}
			if(this.qgform.qgproperty.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.submitqg_lang.qgproperty,'0');
				return false;
			}
			if(this.qgform.qgcode.trim()=='')
			{
				this.$tool.message(this.$lang.label.public.pleasewrite+this.submitqg_lang.qgcode,'0');
				return false;
			}
			if(this.checkedbwtype.length==0)
			{
				this.$tool.message(this.$lang.label.public.pleasecheck+this.submitqg_lang.bwtype,'0');
				return false;
			}
			if(this.qgform.dscompany==''||this.qgform.wlcompany==''||this.qgform.zfcompany=='')
			{
				this.$tool.message(this.$lang.label.public.pleaseselect+this.submitqg_lang.companyname,'0');
				return false;
			}
			this.$tool.loading(this.$lang.label.public.inoperation,this.divclass);
			if(this.batch!=''){
				this.submitqg2(this.batch);
			}else{
				//先插入到临时表
				var that=this;
				this.$apipost.post.InsertTemp({ l_mode: this.pageparam.mode, tab: this.pageparam.tabs[this.pageparam.activeTabIndex].type, search: this.searchinfo, sort: this.pageparam.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.submitqg2(res.batch);
						} else {
							this.$tool.loadingclose();
							this.$tool.message(that.$lang.label.public.getlistfailed, 0);
						}
					} else {
						this.$tool.loadingclose();
						this.$tool.message(that.$lang.label.public.getlistfailed, 0);
					}
				});
			}
		},
		submitqg2(batch){
			var that=this;
			var bwlist=[];
			this.bwlist.forEach(e=>{
				that.checkedbwtype.forEach(b=>{
					if(b.toString()==e.label)
						bwlist.push({"名称":e.value});
				});
			});
			var dsid='',zfid='',wlid='';
			var list=this.companylist_ds.filter(function(e){
				return e.label==that.qgform.dscompany;
			});
			if(list.length==1)
				dsid=list[0].id;
				
			list=this.companylist_zf.filter(function(e){
				return e.label==that.qgform.zfcompany;
			});
			if(list.length==1)
				zfid=list[0].id;
				
			list=this.companylist_wl.filter(function(e){
				return e.label==that.qgform.wlcompany;
			});
			if(list.length==1)
				wlid=list[0].id;
						
			//debugger
			var paraminfo={
				"批次号":batch,
				"申报地":this.qgform.area,
				"关区代码":this.qgform.qgcode,
				"推送报文":bwlist,
				"电商主体":dsid,
				"支付主体":zfid,
				"物流主体":wlid,
				"报文操作类型":this.qgform.handletype,
				"推送账号":this.qgform.qgproperty
			}
			//debugger
			this.$apipost.post.submitqg({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if(res.state=='1'){
						this.$tool.message(that.$lang.label.public.inoperationsuccess, 1);
						setTimeout(function(){
							that.isshow=false;
						},500);
					}
					else if(res.batchid!=undefined){
						this.$tool.message(that.$lang.label.public.handlefailed, 0);
						that.$tool.CreateErrorFile(that,res,batchid);
					}
				} else {
					this.$tool.message(that.$lang.label.public.handleerr, 0);
				}
			}).catch((err) => {
				this.$tool.loadingclose();
				this.$tool.message(that.$lang.label.public.handleerr, 0);
			});
		}		
	}
}
</script>

<style>
</style>